<script setup lang="ts">
import type { GakugeiinBodyProps } from '@/types/appTypes'

const props = withDefaults(defineProps<GakugeiinBodyProps>(), {})

const app = useNuxtApp()
const storeIndex = useStoreIndex()

const custom = props.item.custom as any

const sJobType = ref(null) // カテゴリ
const sJobCarrer = ref(null) // 雇用形態
const sJobCategory = ref(null) // 職種
const sVenue = ref(null) // 会場
const sAddress = ref(null) // 住所
const sTell = ref(null) // TEL
const parsedTel = reactive({
  number: '',
  href: '',
  label: '',
})

if (props.item.custom) {
  if (!sJobCategory.value && props.item.custom.job_category) {
    sJobCategory.value = app.$getDefineNameByID(storeIndex.state.master.job_category.details, props.item.custom.job_category)
  }
  // カテゴリ

  if (!sJobType.value && props.item.custom.job_type) {
    sJobType.value = app.$getDefineNameByID(storeIndex.state.master.job_type.details, props.item.custom.job_type)
  }
  // 雇用形態

  if (!sJobCarrer.value && props.item.custom.job_carrer) {
    sJobCarrer.value = app.$getDefineNameByID(storeIndex.state.master.job_carrer.details, props.item.custom.job_carrer)
  }
  // 職種
}

// 会場・住所・電話番号を取得
if (props.item) {
  if (!sVenue.value) {
    sVenue.value = app.$getEventVenue(props.item, false)
  } // 会場
  if (!sTell.value) {
    sTell.value = app.$getEventTell(props.item)
  } // 電話番号
  if (!sAddress.value) {
    sAddress.value = app.$getEventAddress(props.item, true)
  } // 住所
}

// 電話番号のパース
const setParsedTel = () => {
  const raw = sTell.value || ''
  const match = raw.match(/[\d-]+/)

  parsedTel.number = match ? match[0] : ''
  parsedTel.href = match ? match[0].replace(/-/g, '') : ''
  parsedTel.label = match ? raw.replace(match[0], '') : ''
}
setParsedTel()
</script>

<template>
  <div class="c-container">
    <div
      v-if="item && item.title"
      class="c-header"
    >
      <div class="c-header_title">
        {{ item.title }}
      </div>
    </div>
    <v-divider
      class="c-divider"
    />

    <!-------------------------------------------->
    <div class="c-info">
      <table>
        <tbody>
          <tr
            v-if="item && item.custom && item.custom.company"
          >
            <td>会社・団体名</td>
            <td>{{ item.custom.company }}</td>
          </tr>
          <tr
            v-if="item && item.custom && item.custom.person"
          >
            <td>担当者</td>
            <td>{{ item.custom.person }}</td>
          </tr>
          <tr
            v-if="item && item.custom && item.custom.jis_no"
          >
            <td>勤務地（都道府県）</td>
            <td>{{ storeIndex.getPrefName(item.custom.jis_no) }}</td>
          </tr>
          <tr
            v-if="item && item.custom && item.custom.location"
          >
            <td>勤務先（館名）</td>
            <td>
              <div
                v-html="app.$trimEnter(item.custom.location)"
              />
            </td>
          </tr>
          <tr
            v-if="sJobCategory"
          >
            <td>カテゴリ</td>
            <td>{{ sJobCategory }}</td>
          </tr>
          <tr
            v-if="item && item.custom && item.custom.tel"
          >
            <td>TEL</td>
            <td>{{ item.custom.tel }}</td>
          </tr>
          <tr
            v-if="item && item.custom && item.custom.fax"
          >
            <td>FAX</td>
            <td>{{ item.custom.fax }}</td>
          </tr>
          <tr
            v-if="item && item.custom && item.custom.mail"
          >
            <td>E-mail</td>
            <td>{{ item.custom.mail }}</td>
          </tr>
          <tr
            v-if="item && item.custom && item.custom.web"
          >
            <td>詳細ページURL</td>
            <td>
              <a
                v-bind:href="item.custom.web"
                class="c-info_web"
                target="_blank"
              >
                {{ item.custom.web }}
              </a>
            </td>
          </tr>
          <tr
            v-if="item && item.open_date"
          >
            <td>情報の公開日</td>
            <td>{{ app.$getPeriodDayLabelNoDD(item.open_date) }}</td>
          </tr>
          <tr
            v-if="item && item.custom && item.term_to"
          >
            <td>締切</td>
            <td
              class="c-info_closedate"
            >
              {{ app.$getPeriodDayLabelNoDD(item.term_to) }}
            </td>
          </tr>
          <tr
            v-if="item && item.custom && item.custom.pr"
          >
            <td>一言PR</td>
            <td>
              <div
                v-html="app.$trimEnter(item.custom.pr)"
              />
            </td>
          </tr>
          <tr
            v-if="item && item.custom && item.custom.description"
          >
            <td>仕事内容</td>
            <td>
              <div
                v-html="app.$trimEnter(item.custom.description)"
              />
            </td>
          </tr>
          <tr
            v-if="sJobType"
          >
            <td>職種</td>
            <td>{{ sJobType }}</td>
          </tr>
          <tr
            v-if="sJobCarrer"
          >
            <td>雇用形態</td>
            <td>{{ sJobCarrer }}</td>
          </tr>

          <tr
            v-if="item && item.custom && item.custom.jobtime"
          >
            <td>勤務時間</td>
            <td>
              <div
                v-html="app.$trimEnter(item.custom.jobtime)"
              />
            </td>
          </tr>
          <tr
            v-if="item && item.custom && item.custom.reset"
          >
            <td>休日・休暇</td>
            <td>
              <div
                v-html="app.$trimEnter(item.custom.reset)"
              />
            </td>
          </tr>
          <tr
            v-if="item && item.custom && item.custom.requirements"
          >
            <td>応募資格</td>
            <td>
              <div
                v-html="app.$trimEnter(item.custom.requirements)"
              />
            </td>
          </tr>
          <tr
            v-if="item && item.custom && item.custom.salary"
          >
            <td>給与</td>
            <td>
              <div
                v-html="app.$trimEnter(item.custom.salary)"
              />
            </td>
          </tr>
          <tr
            v-if="item && item.custom && item.custom.treatment"
          >
            <td>待遇</td>
            <td>
              <div
                v-html="app.$trimEnter(item.custom.treatment)"
              />
            </td>
          </tr>
          <tr
            v-if="item && item.custom && item.custom.subscribe"
          >
            <td>応募方法</td>
            <td>
              <div
                v-html="app.$trimEnter(item.custom.subscribe)"
              />
            </td>
          </tr>
          <tr
            v-if="sVenue"
          >
            <td>ミュージアム名</td>
            <td>
              <div v-html="sVenue" />
            </td>
          </tr>
          <tr
            v-if="sAddress || sTell || (item && item.custom && item.custom.museum_eye_catch_image_object)"
          >
            <td>住所</td>
            <td>
              <div v-if="sAddress">
                <div v-html="app.$trimEnter(sAddress)" />
              </div>

              <div
                v-if="sTell"
                class="pc-only"
              >
                {{ sTell }}
              </div>
              <div
                v-if="parsedTel.number"
                class="sp-only"
              >
                <a
                  v-bind:href="'tel:' + parsedTel.href"
                >
                  {{ parsedTel.number }}
                </a>{{ parsedTel.label }}
              </div>

              <div
                v-if="custom?.museum_eye_catch_image_object && objects"
                class="c-info_image"
              >
                <CommonImage
                  class="c-info_image_item"
                  v-bind:src="storeIndex.getImgInfoByID(custom.museum_eye_catch_image_object, objects)?.url"
                  error-src="/images/noimage.svg"
                  v-bind:alt="item.title"
                  aspect-ratio="3/2"
                  object-fit="contain"
                />
              </div>

              <div
                v-if="custom?.museum_article_slug"
                class="c-info_museumlink"
              >
                <ArrowLink
                  v-if="item.article_do_not_link"
                  v-bind:to="{ path: `/museum/${custom.museum_article_slug}` }"
                  label="ミュージアムの詳細をみる"
                  bold
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.c-header {
  &_title {
    margin-bottom: 10px;
    font-size: 26px;
  }
}

.c-history {
  display: flex;
  align-items: flex-start;
  margin-top: 30px;
  padding: 35px 20px;
  padding-bottom: 7px;
  background: #f8fafb;

  @include responsive.mq_down(sp) {
    display: block;
    padding: 20px 16px;
  }

  &_title {
    width: 115px;
    margin-right: 60px;

    @include responsive.mq_down(sp) {
      margin: 0 0 20px;
    }

    &_text {
      padding: 3px 15px;
      border: 1px solid #ebebeb;
      border-radius: 15px;
      background: #fff;
      font-size: 14px;
    }
  }

  &_list {
    display: flex;
    flex-wrap: wrap;
    width: calc(100% - 115px);

    @include responsive.mq_down(sp) {
      margin-top: -15px;
    }

    &_item {
      width: 50%;
      margin-bottom: 15px;
      font-size: 14px;

      @include responsive.mq_down(sp) {
        margin: 15px 0 0;
      }

      &_kind {
        margin-bottom: 3px;
        font-weight: bold;

        &_icon_square {
          display: inline-block;
          position: relative;
          top: -2px;
          width: 8px;
          height: 8px;
          margin-right: 5px;
          background: var(--color_primary_link);
        }
      }

      &_content {
        &_closedate {
          color: #c20000;
        }
      }
    }
  }
}

.c-info {
  margin-top: 40px;

  &_web {
    color: var(--color_primary_link);
  }

  &_closedate {
    color: #c20000;
  }

  &_image {
    position: relative;
    width: 100%;
    margin-top: 20px;

    &_item {
      top: 0;
      left: 0;
      width: 100%;
      background-color: #ebebeb;
    }
  }

  &_museumlink {
    display: flex;
    justify-content: flex-end;
    margin-top: 7px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;

    @include responsive.mq_down(sp) {
      display: block;
    }

    tr,
    th,
    td {
      @include responsive.mq_down(sp) {
        display: block;
      }
    }

    tr {
      td {
        padding: 9px 20px;
        border: 1px solid #ebebeb;

        @include responsive.mq_down(sp) {
          padding: 6px 10px;
          word-break: break-all;
        }

        &:first-child {
          width: 190px;
          border: 1px solid #ebebeb;
          background: #ebebeb;
          color: #252525;
          font-weight: bold;

          @include responsive.mq_down(sp) {
            width: 100%;
          }
        }

        &:last-child {
          width: calc(100% - 190px);
          line-height: 1.85;

          @include responsive.mq_down(sp) {
            width: 100%;
            padding-bottom: 16px;
          }
        }
      }
    }
  }
}
</style>
